/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { AdminDataWorkGrantDTO } from './AdminDataWorkGrantDTO';
import {
    AdminDataWorkGrantDTOFromJSON,
    AdminDataWorkGrantDTOFromJSONTyped,
    AdminDataWorkGrantDTOToJSON,
    AdminDataWorkGrantDTOToJSONTyped,
} from './AdminDataWorkGrantDTO';
import type { AdminDataWorkOpenAccessDTO } from './AdminDataWorkOpenAccessDTO';
import {
    AdminDataWorkOpenAccessDTOFromJSON,
    AdminDataWorkOpenAccessDTOFromJSONTyped,
    AdminDataWorkOpenAccessDTOToJSON,
    AdminDataWorkOpenAccessDTOToJSONTyped,
} from './AdminDataWorkOpenAccessDTO';
import type { AdminDataWorkOrcidSyncDTO } from './AdminDataWorkOrcidSyncDTO';
import {
    AdminDataWorkOrcidSyncDTOFromJSON,
    AdminDataWorkOrcidSyncDTOFromJSONTyped,
    AdminDataWorkOrcidSyncDTOToJSON,
    AdminDataWorkOrcidSyncDTOToJSONTyped,
} from './AdminDataWorkOrcidSyncDTO';
import type { ReferencedOrganisationDTO } from './ReferencedOrganisationDTO';
import {
    ReferencedOrganisationDTOFromJSON,
    ReferencedOrganisationDTOFromJSONTyped,
    ReferencedOrganisationDTOToJSON,
    ReferencedOrganisationDTOToJSONTyped,
} from './ReferencedOrganisationDTO';
import type { ReferencedProjectDTO } from './ReferencedProjectDTO';
import {
    ReferencedProjectDTOFromJSON,
    ReferencedProjectDTOFromJSONTyped,
    ReferencedProjectDTOToJSON,
    ReferencedProjectDTOToJSONTyped,
} from './ReferencedProjectDTO';

/**
 * 
 * @export
 * @interface AdminDataWorkDTO
 */
export interface AdminDataWorkDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataWorkDTO
     */
    changed?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataWorkDTO
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkDTO
     */
    deskman?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkDTO
     */
    editorialStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDataWorkDTO
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkDTO
     */
    license?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkDTO
     */
    licenseManagementStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkDTO
     */
    licenseText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDataWorkDTO
     */
    obligatoryDelivery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDataWorkDTO
     */
    projectsChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkDTO
     */
    origin?: string;
    /**
     * 
     * @type {Array<ReferencedOrganisationDTO>}
     * @memberof AdminDataWorkDTO
     */
    organisations?: Array<ReferencedOrganisationDTO>;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof AdminDataWorkDTO
     */
    projects?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {AdminDataWorkOpenAccessDTO}
     * @memberof AdminDataWorkDTO
     */
    adminDataWorkOpenAccess?: AdminDataWorkOpenAccessDTO;
    /**
     * 
     * @type {Array<AdminDataWorkOrcidSyncDTO>}
     * @memberof AdminDataWorkDTO
     */
    adminDataWorkOrcidSyncs?: Array<AdminDataWorkOrcidSyncDTO>;
    /**
     * 
     * @type {AdminDataWorkGrantDTO}
     * @memberof AdminDataWorkDTO
     */
    grant?: AdminDataWorkGrantDTO;
}

/**
 * Check if a given object implements the AdminDataWorkDTO interface.
 */
export function instanceOfAdminDataWorkDTO(value: object): value is AdminDataWorkDTO {
    return true;
}

export function AdminDataWorkDTOFromJSON(json: any): AdminDataWorkDTO {
    return AdminDataWorkDTOFromJSONTyped(json, false);
}

export function AdminDataWorkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'changed': json['changed'] == null ? undefined : (new Date(json['changed'])),
                'created': json['created'] == null ? undefined : (new Date(json['created'])),
                  'deskman': json['deskman'] == null ? undefined : json['deskman'],
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
                  'hidden': json['hidden'] == null ? undefined : json['hidden'],
                  'license': json['license'] == null ? undefined : json['license'],
                  'licenseManagementStatus': json['licenseManagementStatus'] == null ? undefined : json['licenseManagementStatus'],
                  'licenseText': json['licenseText'] == null ? undefined : json['licenseText'],
                  'obligatoryDelivery': json['obligatoryDelivery'] == null ? undefined : json['obligatoryDelivery'],
                  'projectsChecked': json['projectsChecked'] == null ? undefined : json['projectsChecked'],
                  'origin': json['origin'] == null ? undefined : json['origin'],
              'organisations': json['organisations'] == null ? undefined : ((json['organisations'] as Array<any>).map(ReferencedOrganisationDTOFromJSON)),
              'projects': json['projects'] == null ? undefined : ((json['projects'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
                  'adminDataWorkOpenAccess': json['adminDataWorkOpenAccess'] == null ? undefined : AdminDataWorkOpenAccessDTOFromJSON(json['adminDataWorkOpenAccess']),
              'adminDataWorkOrcidSyncs': json['adminDataWorkOrcidSyncs'] == null ? undefined : ((json['adminDataWorkOrcidSyncs'] as Array<any>).map(AdminDataWorkOrcidSyncDTOFromJSON)),
                  'grant': json['grant'] == null ? undefined : AdminDataWorkGrantDTOFromJSON(json['grant']),
    };
}

export function AdminDataWorkDTOToJSON(json: any): AdminDataWorkDTO {
    return AdminDataWorkDTOToJSONTyped(json, false);
}

export function AdminDataWorkDTOToJSONTyped(value?: AdminDataWorkDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'changed': value['changed']?.toISOString(),
        'created': value['created']?.toISOString(),
        'deskman': value['deskman'],
        'editorialStatus': value['editorialStatus'],
        'hidden': value['hidden'],
        'license': value['license'],
        'licenseManagementStatus': value['licenseManagementStatus'],
        'licenseText': value['licenseText'],
        'obligatoryDelivery': value['obligatoryDelivery'],
        'projectsChecked': value['projectsChecked'],
        'origin': value['origin'],
        'organisations': value['organisations'] == null? value['organisations']: (value['organisations'] as Array<any>).map(ReferencedOrganisationDTOToJSON),
        'projects': value['projects'] == null? value['projects']: (value['projects'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'adminDataWorkOpenAccess': AdminDataWorkOpenAccessDTOToJSON(value['adminDataWorkOpenAccess']),
        'adminDataWorkOrcidSyncs': value['adminDataWorkOrcidSyncs'] == null? value['adminDataWorkOrcidSyncs']: (value['adminDataWorkOrcidSyncs'] as Array<any>).map(AdminDataWorkOrcidSyncDTOToJSON),
        'grant': AdminDataWorkGrantDTOToJSON(value['grant']),
    };
}


